<template>
  <div id="app">
    <Main />
  </div>
</template>

<script>
  import "@/styles/_fonts.scss";
  import "@/styles/app.scss";
  import Main from "../main/Main";

  export default {
    name: 'App',
    components: {
      Main
    }
  }
</script>
